export const ANY_EVENT = 1
export const ELD_SUCCESS = 'sync eld success'
export const ELD_REFRESH = 'eldDataUpdateEvent'
export const ELD_RECONNECTED = 'eldOnboardingUpdateEvent'
export const FUEL_CARD_INFO_UPDATE = 'FuelCardInfoUpdateEvent'
export const CHAT_VERSION_UPDATE = 'chat_version_update'
export const SYSTEM_MESSAGE_INSURANCE = 'system_message_insurance'
export const EDIT_DRIVER_IM_UPDATE = 'driver'
